import {Routes, Route, Navigate} from "react-router";
import {RotasEnum} from "@/utils/rotas";
import {lazy} from "react";
import AuthLayout from "@/components/authLayout";
import PainelLayout from "@/components/painelLayout";
import ProdutoProvider from "@/contexts/produto";


const LoginPage = lazy(() => import('@/pages/auth/login'));


const HomePage = lazy(() => import('@/pages/painel/home'));
const ProdutosPage = lazy(() => import('@/pages/painel/produtos'));
const AddProdutoPage = lazy(() => import('@/pages/painel/produtos/add'));
const EditProdutoPage = lazy(() => import('@/pages/painel/produtos/edit'));
const ProdutosMetricasPage = lazy(() => import('@/pages/painel/produtos/metricas'));
const ClassificacoesPage = lazy(() => import('@/pages/painel/classificacoes'));
const TiposDeCulturaPage = lazy(() => import('@/pages/painel/tiposDeCultura'));
const NutrientesPage = lazy(() => import('@/pages/painel/nutrientes'));
const ListUsuariosPage = lazy(() => import('@/pages/painel/usuarios'));
const EditUsuarioPage = lazy(() => import('@/pages/painel/usuarios/edit'));
const AddUsuarioPage = lazy(() => import('@/pages/painel/usuarios/add'));
const ListTiposDeDocumentoPage = lazy(() => import('@/pages/painel/tiposDeDocumento'));

const NotFoundPage = lazy(() => import('@/pages/notFound'));

const SiteProdutoPage = lazy(() => import('@/pages/site/produto'));



export default function Rotas () {
    return (
        <Routes>
            <Route index element={<Navigate to={RotasEnum.LOGIN} />}/>
            <Route path={RotasEnum.AUTH} element={<AuthLayout />}>
                <Route path={RotasEnum.LOGIN} element={<LoginPage />}/>
            </Route>
            <Route path={RotasEnum.PAINEL} element={<PainelLayout />}>
                <Route index element={<HomePage />}/>
                <Route path={RotasEnum.PRODUTOS} element={<ProdutosPage />}/>
                <Route path={RotasEnum.PRODUTOS_ADD} element={<ProdutoProvider><AddProdutoPage /></ProdutoProvider>}/>
                <Route path={RotasEnum.PRODUTOS_EDIT} element={<ProdutoProvider><EditProdutoPage /></ProdutoProvider>}/>
                <Route path={RotasEnum.PRODUTOS_METRICAS} element={<ProdutosMetricasPage />}/>
                <Route path={RotasEnum.CLASSIFICACOES} element={<ClassificacoesPage />}/>
                <Route path={RotasEnum.TIPOS_DE_CULTURA} element={<TiposDeCulturaPage />}/>
                <Route path={RotasEnum.NUTRIENTES} element={<NutrientesPage />}/>
                <Route path={RotasEnum.USUARIOS} element={<ListUsuariosPage />}/>
                <Route path={RotasEnum.USUARIOS_ADD} element={<AddUsuarioPage />}/>
                <Route path={RotasEnum.USUARIOS_EDIT} element={<EditUsuarioPage />}/>
                <Route path={RotasEnum.TIPOS_DE_DOCUMENTOS} element={<ListTiposDeDocumentoPage />}/>
            </Route>
            <Route path={RotasEnum.SITE_PRODUTO} element={<SiteProdutoPage />}/>
            <Route path={RotasEnum.NOT_FOUND} element={<NotFoundPage />}/>
            <Route path="*" element={<Navigate to={RotasEnum.NOT_FOUND} />}/>
        </Routes>
    )
}